import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';

const tooltipVariants = cva(
  'absolute bg-slate-200 rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible',
  {
    variants: {
      position: {
        bottom: 'top-full left-1/2 -translate-x-1/2 mt-2 w-max',
      },
      size: {
        md: 'max-w-[202px]',
      },
    },
    defaultVariants: {
      position: 'bottom',
      size: 'md',
    },
  }
);

const arrowVariants = cva('absolute w-0 h-0 border-transparent', {
  variants: {
    position: {
      bottom: 'bottom-full left-1/2 -translate-x-1/2 border-l-[6px] border-r-[6px] border-b-[6px] border-b-slate-200',
    },
  },
  defaultVariants: {
    position: 'bottom',
  },
});

interface ITooltipProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof tooltipVariants> {
  readonly children: React.ReactNode;
  readonly content?: string;
}

export function Tooltip({ children, content, position, size, className, ...props }: ITooltipProps) {
  return (
    <span className="relative group cursor-pointer">
      {children}
      <div className={tooltipVariants({ position, size, className })} role="tooltip" {...props}>
        <div className="p-[18px] font-normal">{content}</div>
        <div className={arrowVariants({ position })} />
      </div>
    </span>
  );
}
